import { useCallback, useState } from 'react';
import Axios from '@/utils/Axios';
import { getUrlAPI } from '@/utils/Path';

export default function useApiCreate(url: string) {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const handleCreate = useCallback(
    async (data: any) => {
      try {
        setLoading(true);
        const res = await Axios.post(getUrlAPI(url), data);
        setData(res.data);
        return res.data;
      } catch (error: any) {
        setError(error);
      }
    },
    [url]
  );

  return { data, error, loading, handleCreate };
}

// create demo
// const { data, error, loading, handleCreate } = useApiCreate('https://NRCT/seed/create');
// const body = {};
// handleCreate(body);
